<template>
  <Modal
    hide-close-button
    :offset-menu="offsetMenu"
    persistent
  >
    <template #header>
      <div class="row q-col-gutter-x-sm bigger2 bold items-center">
        <div>
          <QIcon
            color="ds-yellow-6"
            name="ion-warning"
          />
        </div>
        <div>
          {{ title }}
        </div>
      </div>
    </template>

    <i18n-t
      keypath="modals.content_warning_modal.text"
      scope="global"
    >
      <template #legalName>
        {{ appConfig.legalName }}
      </template>

      <template #subTextAvailable>
        <strong>{{
          $t("modals.content_warning_modal.sub_text_available")
        }}</strong>
      </template>
    </i18n-t>

    <a
      class="link"
      :href="appConfig.urls.contentWarning"
      rel="noopener noreferrer"
      target="_blank"
    >
      {{ $t("modals.content_warning_modal.read_more") }}
    </a>

    <div
      v-if="canIgnore"
      class="q-mt-md"
    >
      <Checkbox
        v-model="hideWarning"
        :label="$t('modals.content_warning_modal.toggle_warning_label')"
        new-design
      />
    </div>

    <template #buttons>
      <BaseButton
        color="primary"
        :label="$t('global.ok')"
        new-design
        @click="onConfirm"
      />
    </template>
  </Modal>
</template>

<script>
import { storeToRefs } from "pinia";

import { getLocaleText } from "shared/boot/i18n";
import BaseButton from "shared/components/base/BaseButton.vue";
import Modal from "shared/components/core/modals/Modal.vue";
import { useGlobalStore } from "shared/stores/global";

export default {
  name: "ContentWarningModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    title: {
      type: String,
      default: () =>
        getLocaleText("modals.content_warning_modal.default_title"),
    },
    canIgnore: {
      type: Boolean,
    },
    offsetMenu: {
      type: Boolean,
    },
  },
  emits: ["confirm"],
  setup() {
    const globalStore = useGlobalStore();
    const { appConfig } = storeToRefs(globalStore);

    return {
      appConfig,
    };
  },
  data() {
    return {
      hideWarning: false,
    };
  },
  methods: {
    onConfirm() {
      this.$emit("confirm", this.hideWarning);
      this.$modals.close("ContentWarningModal");
    },
  },
};
</script>
